import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  GET_USER_PERSONALIZATION_PENDING,
  GET_USER_PERSONALIZATION_FAILED,
  GET_USER_PERSONALIZATION_FULFILLED,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"

export const getUserPersonalizationPending = () => ({
  type: GET_USER_PERSONALIZATION_PENDING,
})

export const getUserPersonalizationFailed = (error) => ({
  type: GET_USER_PERSONALIZATION_FAILED,
  payload: error,
})

export const getUserPersonalizationFulfilled = (type, data) => ({
  type,
  payload: data,
})

export const getUserPersonlization = () => (dispatch, getState) => {
  dispatch(getUserPersonalizationPending())
  const api = `GET_USER_PERSONALIZATION`
  const apiKey = get(urls, `apiKey.USER.GET_USER_PERSONALIZATION`, ``)

  const template = URITemplate(urls.url[api])
  const state = getState()
  const locale = get(state, `siteLanguage.language`, ``)

  const url = template.expand({
    userId: get(state, `userAccount.userDetails.userId`, ``),
    lang: locale,
  })

  return getTokenAction(dispatch, getState).then((token) => {
    const config = {
      headers: {
        apiKey,
        oktaToken: token.accessToken,
      },
    }

    return axios
      .create(config)
      .get(url)
      .then((response) => {
        const data = get(response, `data`, {})

        dispatch(
          getUserPersonalizationFulfilled(
            GET_USER_PERSONALIZATION_FULFILLED,
            data,
          ),
        )
        return data
      })
      .catch(() => {
        dispatch(getUserPersonalizationFailed())
      })
  })
}
